import { useNavigate, Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Container, Row, Col, Form } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
import TopBar from "./TopBar";
import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";



const DefaultSthan = () => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [categoriesList, setCategoriesList] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [errorMessage, setErrorMessage] = useState("");
    const UPDATE_STHAN_CATEGORY = "update-sthan-category";
    const [errMsg, setErrMsg] = useState("");
    const [sucssMsg, setSucssMsg] = useState("");
    const errRef = useRef();
    const [sthanList, setSthanList] = useState([]);
    const [selectedLevelId, setSelectedLevelId] = useState(auth.level_id);
    const [UserAccessLevels, setUserAccessLevels] = useState([]);

    const showMessage = (type, message) => {
        if (type === 'error') {
            setErrMsg(message);
            setSucssMsg(""); // ensure success message is cleared
        } else if (type === 'success') {
            setSucssMsg(message);
            setErrMsg(""); // ensure error message is cleared
        }

        // Auto-hide after 10 seconds
        setTimeout(() => {
            setErrMsg("");
            setSucssMsg("");
        }, 10000); // 10000ms = 10 seconds
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedLevelId && !selectedCategories) {
            setErrorMessage("Please select a sthan and category.");
            return;
        } else if (!selectedLevelId) {
            setErrorMessage("Please select a sthan.");
            return;
        } else if (!selectedCategories) {
            setErrorMessage("Please select a category.");
            return;
        }
        else {
            setErrorMessage(""); // clear any previous error

            try {
                var data = JSON.stringify({
                    sthan_id: selectedLevelId,
                    category: selectedCategories,
                    setDefault: true
                });

                const response = await axiosPrivate.post(UPDATE_STHAN_CATEGORY, data, {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                });

                showMessage('success', response?.data?.message);
                // ✅ Redirect after successful update
                if (response?.status === 200) {
                    // Example URL — change this to your desired path
                    window.location.href = "/sthanDashboard/";
                }

            } catch (err) {
                if (!err?.response) {
                    setErrMsg("No Server Response");
                } else if (err.response?.data?.message) {
                    const errorMsg = typeof err.response.data.message === 'string'
                        ? err.response.data.message
                        : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
                    setErrMsg(errorMsg);
                } else {
                    setErrMsg("Registration Failed");
                }
                // errRef.current.focus();
            }
        }
    };

    const fetchSthanCategories = async () => {
        try {
            const response = await axiosPrivate.get('get-categories');
            setCategoriesList(response.data);

            // Set the default dropdown value to the first categories if available
            if (response.data.length > 0) {
                setSelectedCategories(response.data[0].categories);
            }
        } catch (error) {
            console.error("Error fetching categories list:", error);
        }
    };


    const fetchUserAccessLevels = async () => {
        try {
            const response = await axiosPrivate.get('get-user-access-levels');


            // Set the default dropdown value to the first level_id if available
            if (response.data.length > 0) {
                setUserAccessLevels(response.data);
            }
        } catch (error) {
            console.error("Error fetching Sthan list:", error);
        }
    };

    useEffect(() => {
        fetchUserAccessLevels();
    }, []);


    const fetchSthanList = async () => {
        try {
            const response = await axiosPrivate.get('get-user-access-levels');

            if (response.data.length > 0) {
                setSthanList(response.data);

                // Check if current sthan exists in the response
                const exists = response.data.some(item => item.level_id === auth.level_id);

                if (exists) {
                    setSelectedLevelId(auth.level_id);
                } else {
                    setSelectedLevelId(""); // Show blank dropdown
                }
            }
        } catch (error) {
            console.error("Error fetching Sthan list:", error);
        }
    };




    useEffect(() => {
        fetchSthanList();
    }, []);



    useEffect(() => {
        fetchSthanCategories();
    }, []);


    useEffect(() => {
        if (selectedLevelId && sthanList.length > 0) {
            const selectedSthan = sthanList.find(s => s.level_id === Number(selectedLevelId));

            if (selectedSthan && selectedSthan.sthan_category) {
                setSelectedCategories(selectedSthan.sthan_category);
            } else {
                setSelectedCategories(""); // No category available
            }
        }
    }, [selectedLevelId, sthanList]);

    return (

        <Container>

            <section className="adminsec">

                <div className="center-image">

                    {/* <img src="/images/newlogo.png" width="20%" className='' /> */}
                </div>
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">Change Default Sthan of <span className="colorChange">{auth?.name}</span> !</h2> </center>



                <div className="spclrow">
                   <center><p className="dashwel">Current Default Sthan: {auth?.level_name}</p></center> 
                   <Row className="spclrow2">
                    <form onSubmit={handleSubmit}>

                        <Form.Label>Select Sthan</Form.Label>
                        {errorMessage && (
                            <p ref={errRef} tabIndex="-1" style={{ color: 'red', marginTop: '10px' }}>
                                {errorMessage}
                            </p>
                        )}
                        <Form.Control
                            as="select"
                            value={selectedLevelId}
                            onChange={(e) => setSelectedLevelId(Number(e.target.value))}
                            className="vibhaglist"
                        >
                            {/* Optional empty default */}
                            <option value="">-- Select Sthan --</option>

                            {sthanList.map((sthan) => (
                                <option key={sthan.level_id} value={sthan.level_id}>
                                    {sthan.level_name}
                                </option>
                            ))}
                        </Form.Control>

                            <br/>

                        <Form.Control
                            as="select"
                            value={selectedCategories}
                            onChange={(e) => setSelectedCategories(e.target.value)}
                            className="vibhaglist"
                        >
                            <option value="">-- Select Sthan Categories--</option>
                            {categoriesList.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </Form.Control>



                        <button type="submit" className="btn newpagebtn">Submit</button>
                    </form>
                    </Row>
                </div>
            </section>
            <TopBar />
        </Container>
    )
}

export default DefaultSthan
